<div class="avi-alert-bell-body">
    <div
        class="avi-alert-bell-body__spinner"
        *ngIf="alertCollection.busy"
    >
        <ng-container *ngTemplateOutlet="loader"></ng-container>
    </div>

    <div *ngIf="!alertCollection.busy">
        <ng-container *ngFor="let expanderConfig of expanderListConfig; trackBy: trackByIndex; let i = index">
            <right-rail-vertical-expander
                [icon]="expanderConfig.icon"
                [solid]="expanderConfig.solid"
                [headerText]="expanderConfig.headerText"
                [color]="expanderConfig.color"
                [expanded]="i === 0"
            >
                <ng-container *ngFor="let alert of alertCollection.items; trackBy: trackByIndex; let i = index">
                    <div 
                        class="avi-alert-bell-body__alert-grid" 
                        *ngIf="alertLevels[expanderConfig.levelText] == alert.getConfig().level"
                    >
                        <div class="avi-alert-bell-body__alert-text">
                            <div class="avi-alert-bell-body__alert-summary">{{ alert.getConfig().summary }}</div>

                            <span *ngIf="alert.getObjName()">
                                <span>{{ globalL10nKeys.onLabel | vtranslate | lowercase }} </span>
                                <span class="avi-alert-bell-body__alert-obj-name">{{ alert.getObjName() }}</span>
                            </span>
            
                            <span>
                                {{ getPrettyTime(alert.getConfig().timestamp) }}
                            </span>
                        </div>
                        
                        <div
                            class="avi-alert-bell-body__alert-action"
                            *permissionCheck="'PERMISSION_ALERT:WRITE_ACCESS'"
                        >
                            <i
                                class="icon-cancel"
                                (click)="deleteAlert(alert.id)"
                            >
                            </i>
                        </div>
                    </div>
                </ng-container>
            </right-rail-vertical-expander>
        </ng-container>
    </div>
</div>

<ng-template #loader>
    <clr-spinner [clrMedium]="true"></clr-spinner>
</ng-template>
